import Translation from './translation'

export default class Location extends Translation
{

    constructor(location, currentLocale = null){
        super()
        this.id             = 0

        this.locales        = []

        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar     = null
        this.description_en     = null
        this.description_fa     = null

        this.map(location, currentLocale)
        this.init()
    }

    map(location, currentLocale = null){
        if(location == undefined) return

        this.id             = location.id
        
        this.created_at     = location.created_at  
        this.updated_at     = location.updated_at  
        this.published_at   = location.published_at  

        for (let locale in location.translations) {
            this['title_' + locale] = location.translations[locale].title
            this['description_' + locale] = location.translations[locale].description
            this.locales.push(locale);
        }

        if(currentLocale != null){
            this.current_locale = currentLocale
        }else{
            this.setLocale(this.locales)
        }
    }
}

